import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountName'
})
export class AccountNamePipe implements PipeTransform {

  transform(arr: any, code: any): any {
    if ( code == '' || code == null || code == undefined || code == 'undefined' || code == 'All' || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.Account_Name.toString() == code.toString()
      })
    }
  }

}
